import { NumberFormatter } from '@mantine/core';

export function MoneyFormatter({ value, currency = '', prefix = '', useSymbol = true, ...props }) {
  if (useSymbol && prefix) {
    switch (prefix) {
      case 'USD':
        prefix = '$';
        break;
      case 'EUR':
        prefix = '€';
        break;
      case 'GBP':
        prefix = '£';
        break;
      case 'TRY':
        prefix = '₺';
        break;
      default:
        break;
    }
  }

  return (
    <NumberFormatter
      prefix={prefix ? prefix + '' : ''}
      suffix={currency ? ' ' + currency : ''}
      value={value}
      thousandSeparator
      {...props}
    />
  );
}
